import './index.less';

import React from 'react';
import { Button, Icon, Progress, message, Tooltip } from 'antd';
import { connect } from 'react-redux';
import {
  NormalObj,
  MyIcon,
  getSearchParams,
  getToken,
  getLeagueId,
  getUserId,
  getType,
  mergeProps,
  isFzxxUnion,
} from '../../util';
import * as action from '../../redux/action/vod.action';
import api from '../../config/api/index';
import axios from 'axios';
import AxiosWrap from '../../lib/request';
import Alert from '../Alert/Alert';
import TrackRequest from '../../lib/trackRequest';
import downloadSuccess from '../../components/downloadSuccess';
import { isProhibit } from '../../util/prohibitShow';
import { permitDownload } from '../../util/permitDownload';
import { showPPTLearningPlanViewerModal } from '../ppt-learning-plan-viewer';
import WatchFileUpdateRecordButton from './watch-file-update-record-button';
import { downloadFile } from '../../util/download_file';

const { CancelToken } = axios;
const LEARNING_PLAN_FILE_EXTENSIONS = ['ppt', 'pptx'];

// 学案的文件状态
enum LearningPlanRelationStatus {
  // 正在生成
  Generating = 'GENERATING',
  // 生成成功并且包含文件
  SuccessWithFile = 'SUCCESS_WITH_FILE',
  // 生成成功但是没有文件
  SuccessWithoutFile = 'SUCCESS_WITHOUT_FILE',
  // 生成失败
  Failed = 'FAILED',
}

interface Iprops {
  data: NormalObj;
  goToPage?: () => void;
  lessonId: string;
  goToPreview?: (data: any) => void;
  downloadAll?: boolean;
  onCallback?: () => void;
  downloadEntrance: number; // 1 课程课时入口 2 资源包入口 3 全局搜索入口
  previewType: 0 | 1;
  watchEntrance?: number; // 预览入口
  functionConfig: NormalObj;
}
interface Istate {
  loading: boolean;
  title: string;
  isError: boolean;
  percent: number;
  // 点击下载标志
  clickDownload: boolean;
}

function isSupportType(type: string, isSupport?: Boolean | undefined) {
  const supportType = [
    'ppt',
    'pptx',
    'jpg',
    'png',
    'mp3',
    'wma',
    'wav',
    'mp4',
    'swf',
    'xls',
    'xlsx',
    'doc',
    'docx',
    'pdf',
  ];
  if (!isSupport) {
    return supportType.indexOf(type.toLowerCase()) > -1;
  } else {
    return supportType.indexOf(type.toLowerCase()) === -1;
  }
}

class DownloadItem extends React.PureComponent<Iprops, Istate> {
  cancel: any;
  constructor(props: Iprops) {
    super(props);
    this.state = {
      loading: false,
      title: '',
      percent: 0,
      isError: false,
      clickDownload: false,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps: any) {
    const { downloadAll } = nextProps;
    const { loading } = this.state;
    if (downloadAll && !loading) this.onDownload({});
  }

  /**
   * 转化课件名
   *
   * @params name 课件名字
   * @params extension 课件后缀名
   *
   */
  getFileName(name: any, extension: any) {
    if (extension) {
      if (name.includes(`.${extension}`)) {
        return name;
      } else {
        return `${name}.${extension.toLocaleLowerCase()}`;
      }
    }
    return name;
  }

  onDownload = (e: any) => {
    this.setState({
      percent: 0,
    });
    e.stopPropagation && e.stopPropagation();
    const { data, lessonId } = this.props;
    if (!isProhibit(data)) return null;
    const searchParam = getSearchParams(window.location.search);
    const title = data.fileName;
    const fileName = this.getFileName(data.fileName, data.extension);
    this.setState({ isError: false });

    const _name_ = encodeURIComponent(fileName);

    if (data.category === 6 && data.extension.toLowerCase() === 'pdf') {
      const userId = getUserId();
      // 试卷加密
      const link = `${
        api.resourceCenterDownload
      }/FileService/DownloadPdf?usertoken=${getToken()}&fileid=${
        data.fileId
      }&leagueId=${getLeagueId()}&relationUserId=${userId}&fileName=${_name_}`;
      // 浏览器下载
      // this.downloadBlob(title, '', data, link, true, 20);
      this.downloadFileWithBrowser(title, link);

      // 加密试卷下载状态

      const url = `${api.api}/resources/${data.resourceGuid}/files/${
        data.fileId
      }/download?courseId=${searchParam.courseId || data.courseId}&lessonId=${
        lessonId || data.lessonId
      }&fileName=${_name_}&originalFileId=${data.originalFileId || ''}&documentId=${
        data.documentId || ''
      }`;
      if (url) {
        AxiosWrap({
          url,
          method: 'get',
        });
      }
    } else {
      const _name_ = encodeURIComponent(data.fileName);
      const url = `${api.api}/resources/${data.resourceGuid}/files/${
        data.fileId
      }/download?courseId=${searchParam.courseId || data.courseId}&lessonId=${
        lessonId || data.lessonId
      }&fileName=${_name_}&originalFileId=${data.originalFileId || ''}&documentId=${
        data.documentId || ''
      }`;
      if (url) {
        AxiosWrap({
          url,
          method: 'get',
        })
          .then((res: any) => {
            this.webDownloadFn(res, title, data);
          })
          .catch((err) => {
            if (err && err.data) {
              message.error(err.data.message);
            }
          });
      }
    }
  };

  // 浏览器下载
  webDownloadFn(res: any, title: any, data: any) {
    let url = res.data.cdnUrl || res.data.url;
    if (url) {
      url = `https${url.substring(url.indexOf(':'))}`;
      // 浏览器下载
      // this.downloadBlob(title, '', data, url);
      this.downloadFileWithBrowser(title);
    } else {
      Alert.open('该文件暂时无法下载，请联系客服');
    }
  }

  downloadFileWithBrowser(title: any, encryptUrl?: string) {
    this.setState({ loading: true, title });
    const { data: lessonInfo, downloadEntrance } = this.props;

    try {
      // const link = document.createElement('a');
      // link.href = url;
      // link.download = title;
      // link.style.display = 'none';
      // document.body.appendChild(link);
      // link.click();
      // document.body.removeChild(link);

      // this.cancel = () => {
      //   this.setState({ isError: false, loading: false, percent: 0 });
      //   this.props.onCallback && this.props.onCallback();
      // };
      const { fileId, fileName } = lessonInfo;
      downloadFile(fileId, () => {}, fileName, encryptUrl);
      downloadSuccess();
      // 下载资料 埋点
      const searchParam = getSearchParams(window.location.search);
      const { lessonId, data } = this.props;
      TrackRequest({
        name: 'download_material',
        data: {
          course_id: searchParam.courseId || data.courseId,
          period_id: lessonId || data.lessonId,
          material_id: lessonInfo.resourceGuid,
          material_type: lessonInfo.category,
          download_entrance: downloadEntrance,
        },
      });
      // 全局搜索入口不显示下载按钮
      this.setState({
        loading: false,
        clickDownload: downloadEntrance === 3 ? false : true,
        percent: 0,
      });
      this.props.onCallback && this.props.onCallback();
    } catch (err) {
      this.props.onCallback && this.props.onCallback();
      this.setState({ isError: true, loading: false, percent: 0 });
    }
  }

  downloadBlob(
    title: any,
    trackData: any,
    data: any,
    url: any,
    noCache?: boolean,
    basePercent?: number,
  ) {
    this.setState({ loading: true, title });
    if (basePercent) {
      let n = 0;
      const timer = window.setInterval(() => {
        if (n >= 3) {
          window.clearInterval(timer);
        }
        n++;
        this.setState({ percent: Math.floor(basePercent / 4) * n });
      }, 20);
    }
    const { data: lessonInfo, downloadEntrance } = this.props;
    let cache = {};
    !noCache && (cache = { 'Cache-Control': 'no-cache' });
    axios({
      url,
      method: 'GET',
      responseType: 'blob',
      headers: cache,
      onDownloadProgress: (progressEvent) => {
        const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        if (basePercent) {
          // 加密过程模拟进度条
          const _basePercent_ = Math.floor(basePercent / 4) * 4;
          percent >= _basePercent_ && this.setState({ percent });
        } else {
          this.setState({ percent });
        }
        if (percent === 100 || percent === Infinity) {
          setTimeout(() => {
            this.setState({ loading: false, percent: 0 });
            this.props.onCallback && this.props.onCallback();
          }, 2000);
        }
      },
      cancelToken: new CancelToken((c) => {
        this.cancel = c;
      }),
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', title);
        document.body.appendChild(link);
        link.click();
        downloadSuccess();
        // 下载资料 埋点
        const searchParam = getSearchParams(window.location.search);
        const { lessonId, data } = this.props;
        TrackRequest({
          name: 'download_material',
          data: {
            course_id: searchParam.courseId || data.courseId,
            period_id: lessonId || data.lessonId,
            material_id: lessonInfo.resourceGuid,
            material_type: lessonInfo.category,
            download_entrance: downloadEntrance,
          },
        });
      })
      .catch((err) => {
        this.props.onCallback && this.props.onCallback();
        if (axios.isCancel(err)) {
          this.setState({ isError: false, loading: false });
        } else {
          this.setState({ isError: true, loading: false });
        }
      });
  }

  stopDownload = (e: any) => {
    const { percent } = this.state;
    e.stopPropagation();
    if (percent < 100) {
      this.cancel();
      this.setState({ percent: 0 });
    }
  };

  viewLearningPlan = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    const { data, lessonId, previewType } = this.props;
    const searchParam = getSearchParams(window.location.search);
    const wordFile = data.relationFiles[0];
    showPPTLearningPlanViewerModal({
      pptFileId: data.fileId,
      wordFileId: wordFile.relatedFileId,
      previewContext: {
        type: previewType,
        pptFileName: data.fileName,
        wordFileName: wordFile.relatedFileName,
        resourceId: data.resourceGuid,
        courseId: searchParam.courseId || data.courseId,
        lessonId: lessonId || data.lessonId,
        originalFileId: data.originalFileId || '',
        documentId: data.documentId || '',
      },
    });
  };

  renderLearningPlanButton = (
    relationStatus: LearningPlanRelationStatus | undefined,
    hasRelationFile: boolean,
  ) => {
    switch (relationStatus) {
      case LearningPlanRelationStatus.Generating:
        return (
          <Tooltip title="本课件配套的课中学案正在由 AI 生成，请稍等几分钟后刷新页面查看结果。若 AI 最终没有可生成内容，此处不会出现入口。">
            <span
              className="learning-plan-status learning-plan-status-busy"
              onClick={(e) => e.stopPropagation()}
            >
              <Icon type="file-text" />
              <span>AI 正在生成课中学案...</span>
              <Icon type="loading" />
            </span>
          </Tooltip>
        );
      case LearningPlanRelationStatus.SuccessWithFile:
        return hasRelationFile ? (
          <Tooltip title="打开本课件配套的课中学案">
            <Button
              className="learning-plan-status learning-plan-status-ready"
              onClick={this.viewLearningPlan}
            >
              <Icon type="file-text" />
              AI 生成课中学案
            </Button>
          </Tooltip>
        ) : null;
      // case LearningPlanRelationStatus.Failed:
      //   return (
      //     <span
      //       className="learning-plan-status learning-plan-status-muted"
      //       onClick={(e) => e.stopPropagation()}
      //     >
      //       <Icon type="file-text" />
      //       学案生成失败
      //     </span>
      //   );
      // case LearningPlanRelationStatus.SuccessWithoutFile:
      //   return (
      //     <span
      //       className="learning-plan-status learning-plan-status-muted"
      //       onClick={(e) => e.stopPropagation()}
      //     >
      //       <Icon type="file-text" />
      //       学案无可做内容
      //     </span>
      //   );
      default:
        return null;
    }
  };

  previewClick = (e: any) => {
    e.stopPropagation && e.stopPropagation();
    const { data, watchEntrance, lessonId } = this.props;
    const searchParam = getSearchParams(window.location.search);
    const {
      fileId: id,
      extension,
      category,
      fileName,
      // courseId,
      // lessonId,
      resourceGuid,
      originalFileId,
      documentId,
    } = data;
    if (isSupportType(extension, true) || this.isPaper(category, extension)) {
      message.error('暂不支持预览！', 1);
      return;
    }

    const _courseId = searchParam.courseId || data.courseId;
    const _lessonId = lessonId || data.lessonId;

    // 预览埋点
    if (typeof watchEntrance === 'number') {
      const trackData = {
        course_id: _courseId,
        period_id: _lessonId,
        material_id: resourceGuid,
        material_type: category,
        watch_entrance: watchEntrance,
      };
      TrackRequest({ name: 'watch_material', data: trackData });
    }

    this.goToPreView(
      id,
      encodeURIComponent(fileName),
      _courseId,
      _lessonId,
      resourceGuid,
      originalFileId,
      documentId,
    );
  };
  // 判断是否是试卷
  isPaper(category: number, extension: string): boolean {
    if (category === 6 && extension.toLowerCase() === 'pdf') {
      return true;
    }
    return false;
  }

  goToPreView = async (
    id: string,
    fileName: string,
    courseId: string,
    lessonId: string,
    resourceGuid: string,
    originalFileId: string,
    documentId: string,
  ) => {
    const data = await action.filePreview(
      id,
      1,
      fileName,
      courseId,
      lessonId,
      resourceGuid,
      originalFileId,
      documentId,
    );
    if (data && data.fileId) {
      if (this.props.goToPreview) {
        this.props.goToPreview && this.props.goToPreview({ ...data, fileName });
      } else {
        this.props.goToPage && this.props.goToPage();
      }
    }
  };

  render() {
    const {
      data,
      functionConfig: { downloadFile = false },
    } = this.props;
    const { loading, isError, percent, clickDownload } = this.state;
    const { updateState } = data;
    const isLearningPlanFile =
      data.category === 2 &&
      LEARNING_PLAN_FILE_EXTENSIONS.includes((data.extension || '').toLowerCase());
    const hasRelationFile = data.relationFiles?.length > 0;
    // 当前只会存在一个 relationFile，所以取第一个渲染。需求扩张后需重新适配。
    const relationStatus =
      data.relationFiles?.[0]?.relationStatus ||
      (hasRelationFile ? LearningPlanRelationStatus.SuccessWithFile : undefined);

    return (
      <div
        className={`download-item  ${data.expiryState ? 'expire-item' : ''}`}
        onClick={this.previewClick}
      >
        <MyIcon className="iconfont expire-icon" type="iconziyuan" />
        <div className="item-left">
          <div className="item-info">
            <MyIcon className="iconfont" type={getType(data).type} />
            <div className="attachment-item-inner-name" title={data.fileName}>
              {/* {data.previewState && <span className="state-icon pre-icon">已查看</span>} */}
              {updateState && <span className="state-icon update-icon">有更新</span>}
              {!updateState && !isFzxxUnion() && (data.downloadState || clickDownload) && (
                <span className="state-icon down-icon">已下载</span>
              )}
              {data.fileName}
            </div>
          </div>

          {loading && !isError && (
            <div className="download-area">
              <Progress
                percent={this.state.percent}
                status={percent === 100 ? 'success' : !isError ? 'active' : 'exception'}
              />
              <MyIcon
                className="stop-btn"
                type="iconic_del"
                title="取消下载"
                onClick={this.stopDownload}
              />
            </div>
          )}
          {isError && (
            <div
              style={{
                color: '#F5222D',
                padding: '12px 0 23px 60px',
                position: 'relative',
                lineHeight: 0,
              }}
            >
              下载失败!
              <span
                style={{
                  position: 'absolute',
                  color: 'rgba(0, 0, 0, 0.65)',
                  right: '0',
                  fontSize: '8px',
                  top: 8,
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  this.setState({ loading: false, isError: false });
                }}
              >
                <MyIcon type="iconic_del" title="关闭" />
              </span>
            </div>
          )}
        </div>
        <div className="item-right">
          <WatchFileUpdateRecordButton historyFiles={data?.historyFiles} />
          {isLearningPlanFile && this.renderLearningPlanButton(relationStatus, hasRelationFile)}
          {!loading && downloadFile && isProhibit(data) && !permitDownload() && (
            <Button type="primary" onClick={this.onDownload}>
              下载
            </Button>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  functionConfig: { ...state.DynamicControl.functionConfig },
});

export default connect(mapStateToProps, mergeProps)(DownloadItem);
